require('jquery-sticky');

(function ($) {
    $(function () {
        if ($('.menu-navigators-container').length) {
            let windowWidth = $(window).width();
            let topSpacing = 30;
            var pageScrolling;

            if (windowWidth >= 768) {
                topSpacing = 45;
            }

            $(".menu-navigators-container").sticky({
                topSpacing,
                wrapperClassName: 'sticky-navigators'
            });

            $(".menu-navigators-container").on('sticky-start', function () { $('body').addClass('sticky-navigators') });
            $(".menu-navigators-container").on('sticky-end', function () { $('body').removeClass('sticky-navigators') });

            $(window).scroll(function () {
                if ($('.navigator-links') && pageScrolling == false) {
                    $('.navigator-links').each(function () {
                        var hieghtThreshold = $(this).offset().top;
                        var hieghtThreshold_end = $(this).offset().top + $(this).height();
                        var scroll = $(window).scrollTop();
                        var elemId = $(this).attr('id');
                        if (scroll >= hieghtThreshold && scroll <= hieghtThreshold_end) {
                            $('#menu-navigators a').removeClass('active');
                            $('#menu-navigators a[href*="' + elemId + '"]').addClass('active');
                        }
                    });
                }


            });
            $('#menu-navigators a').on('click', function (event) {
                pageScrolling = true;
                $("#menu-navigators a").removeClass("active");
                $(event.currentTarget).addClass("active");

                $('html, body').animate({
                    scrollTop: $($.attr(this, 'href')).offset().top
                }, 700);
                setTimeout(function () {
                    pageScrolling = false;
                }, 710);
            });

            $(window).on('resize', function () {
                windowWidth = $(window).width();
                if (windowWidth >= 768) {
                    topSpacing = 45;
                } else {
                    topSpacing = 30;
                }
                $(".menu-navigators-container").sticky({ topSpacing });
            });
        }
    });
})(jQuery);